import { useCurrentUser } from "@/hooks/useCurrentUser"
import { useIsAllowedPermission } from "@/hooks/useIsAllowedPermission"

const ADMIN_INSTRUCTIONS_URL =
  "https://phantom-instruction.notion.site/2-0-2646eefd7a7a80ab9243f01318341a77"
const USER_INSTRUCTIONS_URL =
  "https://phantom-instruction.notion.site/2-0-2656eefd7a7a802381b9ff7192436bcf?pvs=23"

export function useSupportLinks() {
  const { data: currentUser } = useCurrentUser()
  const isAllowedViewAdminInstructions = useIsAllowedPermission(
    "view:admin_instructions",
  )

  return {
    instructionLinkUrl: isAllowedViewAdminInstructions
      ? ADMIN_INSTRUCTIONS_URL
      : USER_INSTRUCTIONS_URL,
    supportChatLink: currentUser?.org?.support_chat_link?.trim() || null,
  }
}
